import { createFileRoute } from "@tanstack/react-router";
import { useTranslations } from "next-intl";
import { SectionPlaceholder } from "@/components/section-placeholder";

export const Route = createFileRoute("/field")({
  component: FieldPage,
});

function FieldPage() {
  const t = useTranslations("app");
  return (
    <SectionPlaceholder title={t("navField")} body={t("placeholderField")} />
  );
}
